import { VendorBuyOpportunityDetail } from '../../../components/Vendor';

export function BuyOpportunity() {
  return <VendorBuyOpportunityDetail />;
}
